import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { store } from '@/store';
import { CommissionHistoryFilters, CommissionHistoryList } from '../../components';
import {
  changeHistoryQuery,
  commissionSelector,
  getCommissionHistoryFilters,
  getCommissionHistoryList,
  selectHistoryQuery,
} from '../../feature';

const CommissionHistoryTabContainer = () => {
  const dispatch = useAppDispatch();
  const { historyList, historyPagination, isHistoryListLoading } = useAppState(commissionSelector);

  const fetchHistory = useCallback(
    (params: Partial<ReturnType<typeof selectHistoryQuery>>) => {
      const currentQuery = selectHistoryQuery(store.getState()) ?? { page: 1 };
      const mergedQuery = { ...currentQuery, ...params };
      dispatch(changeHistoryQuery(mergedQuery));
      dispatch(getCommissionHistoryList(mergedQuery));
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(getCommissionHistoryFilters());
    fetchHistory({ page: 1 });
  }, [dispatch, fetchHistory]);

  const handlePageChange = (page: number) => {
    fetchHistory({ page });
  };

  return (
    <>
      <CommissionHistoryFilters />
      <CommissionHistoryList
        history={historyList}
        isLoading={isHistoryListLoading}
        currentPage={historyPagination?.current_page ?? 1}
        total={historyPagination?.total ?? 0}
        pageSize={historyPagination?.per_page ?? 25}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default CommissionHistoryTabContainer;
